/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MoreActionsIcon = /*#__PURE__*/ createSvgIcon(
  'MoreActionsIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.496 11.5c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 014 9.996c0-.414.147-.767.442-1.059A1.456 1.456 0 015.504 8.5c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 01-1.062.437zm4.5 0c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 018.5 9.996c0-.414.147-.767.442-1.059a1.456 1.456 0 011.062-.437c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 01-1.062.437zm4.5 0c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0113 9.996c0-.414.147-.767.442-1.059a1.456 1.456 0 011.062-.437c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 01-1.062.437z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MoreActionsIcon;
